
import L from 'leaflet';

let southWest = new L.LatLng(56.06239, 64.268402),
    northEast = new L.LatLng(58.275331, 67.019592);

let map = new L.Map('map', {
    zoomControl: false,
    center: new L.LatLng(document.clat, /*57.146960113233, 65.548178937072*/ document.clon),
    zoom: 17,
    attributionControl: false,
    maxBounds: new L.LatLngBounds(southWest, northEast)
});

let tileserver = new L.TileLayer('https://tile.tgt72.ru/{z}/{x}/{y}.png', {maxZoom: 18});
map.addLayer(tileserver);
map.addControl(L.control.zoom({position: 'topright'}));

let tlIcon = L.icon({
    iconUrl: document.iconUrl,
    iconSize: [16, 16],
    iconAnchor: [16, 16]
});

L.marker([document.clat, document.clon], {icon: tlIcon}).addTo(map).bindPopup(document.objectTitle, {offset: new L.Point(-7, -7)}).openPopup();


// WEBPACK FOOTER //
// ./src/js/trafficLightDetail.js